// Users can shadow this file to define the scope of live code examples.
// See https://primer.style/doctocat/usage/live-code for more details
const codeScope = {};
export default codeScope;
